let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jJkV2")).then(() => parcelRequire('l5F6h'));